export default __webpack_public_path__ + "static/media/08.67554968.jpg";